import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import sampleImage from "../assets/Blackwomen/BWI8.jpg"; // Replace with real image

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={onClick}
      className="w-full text-left py-4 px-6 flex items-center justify-between bg-[#F3FAF9] hover:bg-[#e6f1f0] transition-colors"
    >
      <span className="uppercase text-sm tracking-wide text-gray-700">{title}</span>
      {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
    </button>
    {isOpen && <div className="px-6 pb-4 text-gray-700 text-sm">{children}</div>}
  </div>
);

export default function WebsiteGlowUp() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleIndex = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <div className="max-w-6xl mx-auto mt-12 px-4 grid grid-cols-1 md:grid-cols-2 gap-10 items-start mb-10">
      <div>
        <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">Custom Web Design</p>
        <h1 className="text-4xl  text-gray-900 mb-4">The Website Glow-Up</h1>
        <p className="text-gray-700 mb-8">
          For coaches, consultants, and service pros launching or rebranding with intention.
        </p>

        <div className="border border-gray-200 rounded overflow-hidden shadow-sm">
          <AccordionItem title="What's Included" isOpen={openIndex === 0} onClick={() => toggleIndex(0)}>
            <ul className="list-disc list-inside space-y-1">
              <li>5-page custom site (WordPress or Webflow)</li>
              <li>Conversion-focused layout & UX</li>
              <li>Mobile responsive design</li>
              <li>SEO basics + launch checklist</li>
              <li>Homepage copy guidance</li>
              <li>2–3 week turnaround</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="Not Included" isOpen={openIndex === 1} onClick={() => toggleIndex(1)}>
            <ul className="list-disc list-inside space-y-1">
              <li>Complex booking systems</li>
              <li>Ongoing site updates (available in monthly care plan)</li>
              <li>Product/shop setup</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="Timeline" isOpen={openIndex === 2} onClick={() => toggleIndex(2)}>
            <p>Project delivery within 2–3 weeks of kickoff, assuming timely content from client.</p>
          </AccordionItem>

          <AccordionItem title="Project Investment" isOpen={openIndex === 3} onClick={() => toggleIndex(3)}>
            <p className="mb-3">Base Investment: $1,000</p>
            <ul className="list-disc list-inside space-y-1">
              <li>30% deposit at signing</li>
              <li>40% at start date</li>
              <li>30% upon final delivery</li>
            </ul>
          </AccordionItem>
        </div>

        <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
          <p className="text-gray-700 text-lg">
            <span className="italic">Investment begins at:</span>{" "}
            <span className="text-2xl text-gray-900  font-medium">$1,200</span>
          </p>
          <a href="/contact">
          <button className="bg-[#C18343] text-white uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#a76e33] transition-colors">
            Start Project
          </button>
          </a>
        </div>
      </div>

      <div className="w-full py-24">
        <img src={sampleImage} alt="Custom Web Design preview" className="shadow-xl w-full h-[500px] object-cover" />
      </div>
    </div>
  );
}
